import { allocationDraft } from "../../lib/allocations";
import { formatMoney } from "../../lib/money-math";
import type { ExpenseInput, Transaction } from "../../types";
import type { PriceObservation } from "../../types/receipt";
import { isIncome } from "../../lib/finance";

/** A saved transaction as the entry form's input, to edit it. `prices` are its tracked items. */
export function transactionDraft(t: Transaction, prices: PriceObservation[]): ExpenseInput {
  return {
    requestId: crypto.randomUUID(),
    accountId: t.accountId,
    amount: formatMoney(t.amount),
    type: t.toAccountId ? "Transfer" : isIncome(t) ? "Income" : "Expense",
    toAccountId: t.toAccountId,
    exchangeRate: t.toAccountId ? String(Number(((t.receivedAmount || 0) / t.amount).toFixed(8))) : undefined,
    date: t.date.slice(0, 10),
    time: t.time,
    allocations: allocationDraft(t),
    category: t.category,
    subcategory: t.subcategory,
    title: t.title || t.description,
    // Without this the edit form opens with Payee blank whatever the transaction actually has,
    // and saving sends "" — which now clears it rather than being ignored.
    payeeId: t.payeeId || "",
    draftPayeeName: t.draftPayeeName ?? (t.importedFrom === "sms" ? "" : undefined),
    notes: t.notes,
    reportableAmount: t.reportableAmount === t.amount ? undefined : formatMoney(t.reportableAmount),
    markup: t.markup?.match(/^(\d+(?:\.\d{1,2})?)%?$/)?.[1],
    pending: !!t.pending,
    needsReview: !!t.needsReview,
    tripId: t.tripId,
    goalId: t.goalId,
    conversionTransactionId: t.currencyConversion?.counterpart.id,
    conversionExpectedUpdatedAt: t.currencyConversion?.counterpart.updatedAt,
    tripDestination: t.tripDestination,
    split: t.split,
    isSettlement: t.isSettlement,
    trackedItems: prices.map((price) => ({
      id: price.observationId,
      name: price.name,
      brand: price.brand,
      group: price.group,
      total: String(price.total),
      measure: price.measure === null ? "" : String(price.measure),
      unit: price.unit,
      pack: price.pack,
      notes: price.notes || "",
    })),
  };
}
